import React, { useCallback, useMemo, useState } from 'react';
import cn from 'classnames';
import Slider from 'components/UI/Slider';
import { CustomDot, CustomPagination } from 'components/UI/Slider/utils';
import MobileCard from './MobileCard';

import * as styles from './MobileLayout.module.scss';

export default function MobileLayout({ items }) {
  const [current, setCurrent] = useState(0);

  const setCurrentKey = useCallback((prev, next) => {
    setCurrent(next);
  }, []);

  const settings = useMemo(
    () => ({
      customPaging: CustomDot.bind(null, items.length, current),
      appendDots: CustomPagination,
      dotsClass: 'slick-pagination',
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: false,
    }),
    [items.length, current],
  );

  return (
    <div className={cn(styles.sliderContainer, 'defaultSlider')}>
      <Slider {...settings} beforeChange={setCurrentKey}>
        {items.map((item, index) => (
          <MobileCard key={index} {...item} />
        ))}
      </Slider>
    </div>
  );
}
